import React from 'react'
import './footer.scss'
function FooterComponent() {
	const location = window.location.hostname
	return (
		<footer className="bg-dark  text-light mt-5 footerfixed">
			{location.includes('breezeparking') ? null : <div className="d-flex align-items-center text-sm justify-content-center">Powered By :
				<img className='brand-img2' height='30px' src="https://parkengage.com/static/media/logo.8ed76367.svg" />
			</div>}
		</footer>
	)
}
export default FooterComponent
